import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { Toast } from 'vant';
import { PullRefresh } from 'vant';
import { ImagePreview } from 'vant';
import { Button } from 'vant';
import { Form, Field, CellGroup,Uploader } from 'vant';
import { Overlay } from 'vant';
import { Loading } from 'vant';

import LoadingPage from './components/LoadingPage.vue'; // 替换为你的实际路径
import NoData from './components/NoData.vue'; // 替换为你的实际路径




//vant 全局样式
import 'vant/lib/toast/style';
import 'vant/lib/pull-refresh/style';
import 'vant/lib/image-preview/style';
import 'vant/lib/button/style';
import 'vant/lib/form/style';
import 'vant/lib/field/style';
import 'vant/lib/cell-group/style';
import 'vant/lib/uploader/style';
import 'vant/lib/dialog/style';
import 'vant/lib/loading/style';
import {getUserInfo, yue} from "@/api/user";
import {storage} from "@/utils/utils";

// import '@/assets/css/global.css'
const app = createApp(App);



app.component('LoadingPage',LoadingPage);
app.component('NoData',NoData);

app.use(Toast);
app.use(PullRefresh);
app.use(ImagePreview);
app.use(Button);
app.use(Form);
app.use(Field);
app.use(CellGroup);
app.use(Uploader);
app.use(Overlay);
app.use(Loading);
app.use(router);

//余额
app.config.globalProperties.$yue=()=>{
    return new Promise((resolve,reject)=>{
        yue({}).then(res=>{
            if(res.code==200){
                let yue = res.data;
                resolve(yue);
                localStorage.setItem("yue",yue);
            }else{
                reject(res);
            }
        })
    })
}

//更新用户信息
app.config.globalProperties.$getUserInfo=()=>{
    return new Promise((resolve,reject)=>{
        getUserInfo({}).then(res=>{
            if(res.code==200){
                let user = res.data;
                storage.set('channel_user', user);
                resolve(user);
            }else{
                reject(res);
            }
        })
    })
}

app.mount('#app')






